export function Container(props: React.PropsWithChildren) {
    return <div className="border rounded-md p-2">{props.children}</div>
}
